"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStore = void 0;
const collection_store_1 = require("./collection.store");
const collection_summary_store_1 = require("./collection.summary.store");
const form_store_1 = require("./form.store");
const form_summary_store_1 = require("./form.summary.store");
const tag_store_1 = require("./tag.store");
const tag_summary_store_1 = require("./tag.summary.store");
const user_profile_store_1 = require("./user.profile.store");
exports.AppStore = {
    Collection: new collection_store_1.CollectionStore(),
    CollectionSummary: new collection_summary_store_1.CollectionSummaryStore(),
    Form: new form_store_1.FormStore(),
    FormSummary: new form_summary_store_1.FormSummaryStore(),
    Tag: new tag_store_1.TagStore(),
    TagSummary: new tag_summary_store_1.TagSummaryStore(),
    UserProfile: new user_profile_store_1.UserProfileStore(),
};
//# sourceMappingURL=index.js.map